module.exports = __webpack_public_path__ + "static/media/forwardIconBlack.c2a7a7cd.svg";